// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  appName: 'OrnSys1',
  apiKey: '123',
  baseUrl:'https://athinathatauatapi.ornsys.com/api/v1'// 'https://athinathataapi.ornsys.com/api/v1',//'https://insapi.ornsys.com/api/v1',//'http://127.0.0.1:8000/api/v1',//
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
